import { createAction } from 'redux-starter-kit';

export const SET_PROJECTS = 'projects/SET_PROJECTS';
export const CLEAR_PROJECTS = 'projects/CLEAR_PROJECTS';
export const SET_PROJECT = 'projects/SET_PROJECT';
export const CLEAR_PROJECT = 'projects/CLEAR_PROJECT';
export const TOGGLE_REMINDER = 'projects/TOGGLE_REMINDER';

export default {
  setProjects: createAction(SET_PROJECTS),
  clearProjects: createAction(CLEAR_PROJECTS),
  setProject: createAction(SET_PROJECT),
  clearProject: createAction(CLEAR_PROJECT),
  toggleReminder: createAction(TOGGLE_REMINDER),
};
